var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleCheck = function SvgCircleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.978 1.333C4.315 1.333 1.334 4.325 1.334 8c0 3.676 2.98 6.667 6.644 6.667s6.645-2.99 6.645-6.667c0-3.676-2.98-6.667-6.645-6.667Zm2.763 5.787L7.928 9.9a1.106 1.106 0 0 1-1.563-.003l-1.142-1.11a.557.557 0 0 1 .385-.956c.145 0 .278.052.386.157l1.148 1.117 2.822-2.778a.553.553 0 0 1 .783.006.557.557 0 0 1-.006.787Z",
    fill: "#249241"
  })));
};
export default SvgCircleCheck;